import { useQuery } from "@tanstack/react-query";
import { ApiGetUserCexOrderTradeStats } from "@/api";
import type {
  GetUserCexOrderTradeStatsRequest,
  GetUserCexOrderTradeStatsResponse,
} from "@/api/types";

/**
 * 获取当前用户自动/手动下单统计
 * 对应接口：`/game/cex/GetUserCexOrderTradeStats`
 */
export function useGetUserCexOrderTradeStats(
  params?: GetUserCexOrderTradeStatsRequest
) {
  return useQuery({
    queryKey: [
      "userCexOrderTradeStats",
      params?.closeTimeFromMs ?? "",
      params?.closeTimeToExclusiveMs ?? "",
    ],
    queryFn: async (): Promise<GetUserCexOrderTradeStatsResponse> => {
      const res = await ApiGetUserCexOrderTradeStats(params ?? {});
      console.log("useGetUserCexOrderTradeStats", res.data);
      return res.data;
    },
  });
}
